/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Decks_DeleteInputs */



/**
* | output |
* | --- |
* | "Delete deck" |
*
* @param {Decks_DeleteInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const decks_delete = /** @type {((inputs?: Decks_DeleteInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Decks_DeleteInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Supprimer le deck")
	if (locale === "es") return /** @type {LocalizedString} */ ("Eliminar deck")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Excluir deck")
	if (locale === "it") return /** @type {LocalizedString} */ ("Elimina deck")
	return /** @type {LocalizedString} */ ("Delete deck")
});